export const getStore = state =>
  (state.storage ? Object.assign({}, state.storage) : null);
export const getCurrent = state => state.current;
export const getOwnershipType = state => state.ownershipType;
export const getProjectType = state => state.projectType;
export const getProjectName = state => state.projectName;
export const getProjectDetails = state => state.projectDetails;
export const getLoanAmount = state => state.loanAmount;
export const getValidateLoanAmount = state => state.validateLoanAmount;
export const getSelectedBank = state => state.selectedBank;
export const getAgreement = state => state.agreement;



// WEBPACK FOOTER //
// ./src/redux/storage/selectors.js